module.exports = __webpack_public_path__ + "img/patelsun.92bfb62a.jpg";